import type { ComponentType } from "react";

type LazyImport = () => Promise<{ default: ComponentType }>;

export const FEATURE_REGISTRY: Record<string, LazyImport> = {
  // ── System Administration ─────────────────────────────────────────────────
  "/dashoboard/chat-bot": () =>
    import("../../features/chatbot/Chatbot").then((m) => ({
      default: m.default,
    })),

  "/account/change-password": () =>
    import("../../features/dashboard/user/components/ChangePasswordForm").then(
      (m) => ({
        default: m.default,
      }),
    ),

  // ── Account Management ────────────────────────────────────────────────────
  "/account/office": () =>
    import("../../features/lkp-location/pages/Lkplocationlistpage").then(
      (m) => ({ default: m.default }),
    ),

  "/lookup/cityzone": () =>
    import("../../features/cityzone/pages/CityZoneListPage").then((m) => ({
      default: m.default,
    })),

  "/lookup/bill-plan": () =>
    import("../../features/mst-bill-plans/pages/Billplanlistpage").then(
      (m) => ({ default: m.default }),
    ),

  "/lookup/bill-plan-type": () =>
    import("../../features/mst-bill-plan-type").then((m) => ({
      default: m.BillPlanTypeListPage,
    })),

  "/lookup/lob": () =>
    import("../../features/line-of-business/pages/Lineofbusinesslistpage").then(
      (m) => ({ default: m.default }),
    ),

  "/lookup/document-owner-type": () =>
    import("../../features/document-owner-type").then((m) => ({
      default: m.DocumentOwnerTypeListPage,
    })),

  "/lookup/document-type": () =>
    import("../../features/document-type/pages/DocTypeListPage").then((m) => ({
      default: m.default,
    })),

  "/lookup/fuel-type": () =>
    import("../../features/fuel-type/Index").then((m) => ({
      default: m.FuelTypeListPage,
    })),
  // "/account/fuel-type": () =>
  //   import("../../features/escort").then((m) => ({
  //     default: m.EscortListPage,
  //   })),
  // ------------------ Amit
  "/lookup/special-cases": () =>
    import("../../features/specialCase").then((m) => ({
      default: m.SpecialCaseListPage,
    })),
  // -------------- Amit End
  "/lookup/employee-type": () =>
    import("../../features/employee-type").then((m) => ({
      default: m.EmployeeTypeListPage,
    })),

  "/lookup/department": () =>
    import("../../features/lkp-department/pages/Departmentlistpage").then(
      (m) => ({ default: m.default }),
    ),

  "/lookup/process": () =>
    import("../../features/lkp-process").then((m) => ({
      default: m.ProcessListPage,
    })),

  "/user/employee": () =>
    import("../../features/employee").then((m) => ({
      default: m.EmployeeListPage,
    })),

  "/account/app-control": () =>
    import("../../features/new-app-control/pages/AppcontrolListPage").then(
      (m) => ({
        default: m.default,
      }),
    ),

  "/account/shift-interval": () =>
    import("../../features/shiftinterval").then((m) => ({
      default: m.ShiftIntervalListPage,
    })),

  //"/account/corporate": () =>

  "/account/corporate-register": () =>
    import("../../features/corporate").then((m) => ({
      default: m.BusinessListPage,
    })),
  "/lookup/current-status": () =>
    import("../../features/currentStatus").then((m) => ({
      default: m.CurrentStatusListPage,
    })),
  "/lookup/state": () =>
    import("../../features/state").then((m) => ({
      default: m.StateListPage,
    })),

  "/account/shift-configuration": () =>
    import("../../features/shift-management").then((m) => ({
      default: m.ShiftManagementPage,
    })),

  
  "/lookup/vehicle-type": () =>
    import("../../features/vehicletype").then((m) => ({
      default: m.VehicleTypeListPage,
    })),
 
  "/lookup/vehicle-status": () =>
    import("../../features/vehicleStatus").then((m) => ({
      default: m.VehicleStatusListPage,
    })),

  "/dashboard/permission-access": () =>
    import("../../features/system-administration").then((m) => ({
      default: m.RolePermissionPage,
    })),
  "/dashboard/menu-permission": () =>
    import("../../features/menu-permission").then((m) => ({
      default: m.default,
    })),
  "/account/shift-management": () =>
    import("../../features/shift-validation/pages/ShiftValidationPage").then(
      (m) => ({
        default: m.ShiftValidationPage,
      }),
    ),

  "/lookup/feedback-type": () =>
    import("../../features/lkp-feedbacktype").then((m) => ({
      default: m.LkpFeedbackTypeListPage,
    })),

  "/lookup/penalty-type": () =>
    import("../../features/lkp-penalty-type").then((m) => ({
      default: m.LkpPenaltyTypeListPage,
    })),

  "/lookup/trip-type": () =>
    import("../../features/lkp-trip-type").then((m) => ({
      default: m.LkpTripTypeListPage,
    })),
  "/account/profile": () =>
    import("../../features/profile/pages/UserProfile").then((m) => ({
      default: m.default,
    })),


  "/account/adhoc-week-days": () =>
    import("../../features/lkp-adhoc-days").then((m) => ({
      default: m.LkpAdhocWeekDaysListPage,
    })),
  

  "/account/notification-management": () =>
    import("../../features/NotificationManagement/index").then((m) => ({
      default: m.default,
    })),

  
  "/reports/analytics": () =>
    import("../../features/report-analytics/pages/ReportPage").then((m) => ({
      default: m.default,
    })),
  "/reports/report-permission": () =>
    import("../../features/report-permission/pages/ReportPage").then((m) => ({
      default: m.default,
    })),
  "/billing/rate-card": () =>
    import("../../features/billing/pages/BillingPage").then((m) => ({
      default: m.default,
    })),
  "/billing/mis-report": () =>
    import("../../features/billing/pages/MISReport").then((m) => ({
      default: m.default,
    })),

  "/reports/add-report": () =>
    import("../../features/report-analytics/index").then((m) => ({
      default: m.CreateReport,
    })),

  "/feedback/complaint-resolution": () =>
    import("../../features/complaint-resolution/pages/ComplaintResolutionPage").then(
      (m) => ({
        default: m.default,
      }),
    ),
  "/billing/generate": () =>
    import("../../features/billing/pages/GenerateBilling").then(
      (m) => ({
        default: m.default,
      }),
    ),
  "/billing/penalty": () =>
    import("../../features/penalty").then(
      (m) => ({
        default: m.PenaltyListPage,
      }),
    ),
  
  "/account/speed-service-grid": () =>
    import("../../features/speed-service-grid/index").then((m) => ({
      default: m.default,
    })),
};
